import { Close } from '../streamlineSolidIcon/Close';
import {
  IconStandardButton,
  type IconStandardButtonProps,
} from './IconStandardButton';

export const CloseButton = (
  props: Omit<IconStandardButtonProps, 'children'>,
) => (
  <IconStandardButton
    aria-label="close"
    data-testid="dialog-close-button"
    size="small"
    sx={{ fontSize: '0.85em' }}
    noBorder
    {...props}
  >
    <Close size="small" />
  </IconStandardButton>
);
